import './timeregistration-work-bar.css';
import { convertValueToHoursAndMinutes } from '../../../utils/convertValueToHoursAndMinutes';

function TimeRegistrationWorkBar({ hours, total, disableWarning }) {
  let calculatedWidth = 0;
  if (total === 0) {
    calculatedWidth = hours > 0 ? 100 : 0;
  } else {
    calculatedWidth = Math.min((hours / total) * 100, 100);
  }
  const overtime = hours > total ? hours - total : 0;
  return (
    <div className="timeregistration-work-bar">
      {convertValueToHoursAndMinutes(hours) === '-'
        ? '0t'
        : convertValueToHoursAndMinutes(hours)}

      <div className="timeregistration-work-bar__graphic">
        <div
          className={`timeregistration-work-bar__graphic timeregistration-work-bar__graphic--filled ${
            !disableWarning && hours >= 48
              ? 'timeregistration-work-bar__graphic--warning'
              : ''
          }`}
          style={{ width: `${calculatedWidth < 0 ? 0 : calculatedWidth}%` }}
        />
        {total !== 0 && overtime > 0 && (
          <div
            className={`timeregistration-work-bar__graphic timeregistration-work-bar__graphic--overtime ${
              !disableWarning && hours >= 48
                ? 'timeregistration-work-bar__graphic--warning'
                : ''
            }`}
          />
        )}
      </div>
    </div>
  );
}

export default TimeRegistrationWorkBar;
